module.exports = __webpack_public_path__ + "img/ca.cd739e76.jpg";